import { nodeHeight, nodeWidth } from '../const/node';
import { useDagreGraph as _useDagreGraph } from 'src/util/hook/flow/index';

export const useDagreGraph = _useDagreGraph.bind(null, {
    nodeHeight,
    nodeWidth,
});
